export const DEFAULT_LOCALE = "en";
export const i18nSeparators = {
    ar: {
        decimal: ".",
        thousand: ",",
    },
    de: {
        decimal: ",",
        thousand: ".",
    },
    en: {
        decimal: ".",
        thousand: ",",
    },
    es: {
        decimal: ",",
        thousand: ".",
    },
    fr: {
        decimal: ",",
        thousand: " ",
    },
    it: {
        decimal: ",",
        thousand: ".",
    },
    ja: {
        decimal: ".",
        thousand: ",",
    },
    nl: {
        decimal: ",",
        thousand: ".",
    },
    pt: {
        decimal: ",",
        thousand: ".",
    },
    ru: {
        decimal: ",",
        thousand: " ",
    },
    th: {
        decimal: ".",
        thousand: ",",
    },
};
export const getSeparators = (locale) => {
    var _a, _b;
    // Sometimes the language will resolve as a contextualized language, like de-DE;
    // in that case we should try `de` first, and fall back to `en` so we never throw errors.
    const langPart = locale.split("-")[0];
    return ((_b = (_a = i18nSeparators[locale]) !== null && _a !== void 0 ? _a : i18nSeparators[langPart]) !== null && _b !== void 0 ? _b : i18nSeparators[DEFAULT_LOCALE]);
};
